var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.b2cLoading && !_vm.redirecting),expression:"!b2cLoading && !redirecting"}]},[_c('ck-header-background'),_c('ck-header'),_c('ck-main'),_c('ck-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }